export default {
    namespaced: true,
    state: () => ({
        user: {}
    }),
    mutations: {
        setUser: function(state, params) {
            state.user = params.user;
        },
    },
    actions: {
        setUser: function(context, params) {
            context.commit('setUser', params);
        }
    }
}